import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { parseAuraRichText } from '@/utils/auraRichText';


export default /*@__PURE__*/_defineComponent({
  __name: 'AuraRichText',
  props: {
    text: { type: String, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;

const lines = computed(() => parseAuraRichText(props.text));

const __returned__ = { props, lines }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})